import React from 'react';

import './AccessibleWrapper.scss';

const AccessibleClickableWrapper = ({
  disabled = false,
  onClick,
  ariaLabel,
  className = '',
  type = 'button',
  children,
  ...rest
}) => {
  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick && onClick(e);
    }
  };

  const handleClick = (e) => {
    if (disabled) return;
    onClick && onClick(e);
  };

  return (
    <button
      className={`accessibleWrapper ${disabled ? 'disabled' : ''} ${className}`}
      type={type}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

export default AccessibleClickableWrapper;
